/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import css from './BrandPromiseItem.APP_TARGET.scss';
import { XX } from 'Constants/images';

const BrandPromiseItem = ({ label, imageURI, subtitle, price }) => {
    function showText(label, minChar) {
        return label ? (label.length > minChar ? `${label.substring(0, minChar)}...` : label) : '';
    }

    const titleMinLength = 22;
    const subTitleMinLength = 36;

    return (

        <div className={ css.boxChip } data-aut-id="brandBannerListItem">
            <div className={ css.box }>
                <div className={ css.tagImg }>
                    <ImageWrapper
                        fileName={ imageURI || '' }
                        fileSize={ XX }
                    />
                </div>
                <div className={ css.boxPrice }>
                    <div className={ css.boxInclude }>
                        <p className={ css.subText }>{ showText(label, titleMinLength) } <span className={ css.priceCross }>{ price && price }</span></p>
                        <p className={ css.description }>{ showText(subtitle, subTitleMinLength) }</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

BrandPromiseItem.propTypes = {
    label: PropTypes.string.isRequired,
    imageURI: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired
};

BrandPromiseItem.defaultProps = {
    isListingPage: false,
    isAdPage: false
};

export default BrandPromiseItem;
